import { render, staticRenderFns } from "./gb-whatsapp-ios.vue?vue&type=template&id=782a5194&scoped=true"
import script from "./gb-whatsapp-ios.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-ios.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-ios.vue?vue&type=style&index=0&id=782a5194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a5194",
  null
  
)

export default component.exports